import { render, staticRenderFns } from "./ShopParameters.vue?vue&type=template&id=38f3bf9a&scoped=true"
import script from "./ShopParameters.vue?vue&type=script&lang=js"
export * from "./ShopParameters.vue?vue&type=script&lang=js"
import style0 from "./ShopParameters.vue?vue&type=style&index=0&id=38f3bf9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f3bf9a",
  null
  
)

export default component.exports